import {dsColorNew} from "@palette";

const inputBg = {
    '& .MuiOutlinedInput-root': { backgroundColor: dsColorNew.filterInputBg },
    '& .MuiInputBase-root': { backgroundColor: dsColorNew.filterInputBg },
    '& .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-cascader .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-select .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-default .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
}

const overrideDialogStyles = () => ({
    MuiDialog: {
        styleOverrides: {
            paper: {
                borderRadius: 16,
                boxShadow: '0 8px 40px rgba(0,0,0,0.14)',
                ...inputBg,
            }
        }
    },
    MuiDialogTitle: {
        styleOverrides: {
            root: {
                background: `linear-gradient(135deg, rgba(37,99,235,0.08), rgba(74,144,217,0.18))`,
                fontSize: '1rem',
                fontWeight: 700,
                color: '#111827',
                padding: '20px 24px 16px',
            }
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: '20px 24px',
            },
            dividers: {
                borderColor: dsColorNew.grayBorder,
            }
        }
    },
    MuiDrawer: {
        styleOverrides: {
            paper: ({ ownerState }) => ({
                ...(ownerState.anchor === 'right' && {
                    boxShadow: '-12px 0 50px rgba(74,144,217,0.2)',
                    ...inputBg,
                })
            })
        }
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: '12px 24px 16px',
                gap: 8,
                borderColor: dsColorNew.grayBorder,
            }
        }
    },
})

export default overrideDialogStyles
